import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { DistributionController } from "@app/ui_controllers/distributionController";
import { ActivatedRoute, Router } from "@angular/router";
import { DistributionPageDto, RegistryDozSpecificationDto } from "@app/ui_models/web-response";
import { MedID, MedOptionType } from "@mk/med-ui";
import { DataService } from "@app/services/data.service";
import { DistributionBeneficiaryDto, DistributionDozQuantityRequest } from "@app/ui_models/model-dto";
import { MedNotificationService } from "@mk/med-notification";
import { tabHeader2, attachmentsTabHeader2, subTabHeader2 } from "./column-headers";
import { env } from "@environments/environment";
import { MedInputStateType } from "@mk/med-ui/lib/components/form/FieldCoreComponent";
import { BasketDozService } from "@app/components/distribution/doz/basket/basketDoz.service";
import { CryptoController } from "@app/ui_controllers/cryptoController";
import { DecryptedObject, SignatureObject } from "@app/ui_models/crypto.model";
import { DistributionDocument, FileAttachment, FileCreationResponse } from "@app/ui_models/document.service.models";
import { DocumentFileApiService } from "@app/services/document.file.api.service";
import { DownloadService } from "@app/services/download.service";
import { DocumentsController } from "@app/ui_controllers/documents.controller";
import { AccountService } from "@app/services/account.service";
import { StatusTranslatorService } from "@app/services/status.translator.service";
import { HttpErrorResponse } from "@angular/common/http";
import { BeneficiaryController } from "@app/ui_controllers/beneficiaryController";
import { catchError } from "rxjs";

@Component({
  selector: "app-distributionDoz",
  templateUrl: "./distributionDoz.component.html",
  styleUrls: ["/distributionDoz.component.scss", "../../distributions/doz/distributions.doz.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DistributionDozComponent implements OnInit {

  constructor(private readonly notificationService: MedNotificationService,
              private readonly documentFileApiService: DocumentFileApiService,
              private readonly documentsController: DocumentsController,
              private readonly accountService: AccountService,
              private distributionController: DistributionController,
              private route: ActivatedRoute,
              private router: Router,
              private dataService: DataService,
              private cryptoController: CryptoController,
              public readonly downloadService: DownloadService,
              public readonly beneficiaryController: BeneficiaryController,
              public basket: BasketDozService,
              public statusTranslatorService: StatusTranslatorService) {}

  selectOptions: MedOptionType<any>[] = [];
  selectedBeneficiariesId: number[] = [];
  distributionId = -1;
  distribution: DistributionPageDto = {} as DistributionPageDto;
  tabHeader: { label: string; key: string; }[] = tabHeader2;
  attachmentsTabHeader: { label: string; key: string; }[] = attachmentsTabHeader2;
  subTabHeader: { label: string; key: string; }[] = subTabHeader2;
  loadingCounter = 0;
  attachmentsModal = false;
  reviewModal = false;
  refuseModal = false;
  signModal = false;
  options: MedOptionType<any>[] = [
    {
      label: "Наказ",
      value: 1,
    },
    {
      label: "Протокол",
      value: 2,
    },
  ];
  refuseOptions: MedOptionType<any>[] = [
    {
      label: "Лист відмови",
      value: 1,
    }
  ];
  value = 1;
  signRequestCounter = 0;
  refuseRequestCounter = 0;
  signed = false;
  refused = false;
  READONLY = false;
  distributionApproved = false;
  subDistributionAgreementModal = false;
  showSubDistributionCreationView = false;
  validations = {};
  validationsPostponed = {};
  selectedBaseId = 0;
  goodSpecsForSelection: RegistryDozSpecificationDto[] = [];
  medSignModal = false;
  signedData = "";
  dataToSign = {} as SignatureObject;
  decryptedObject: DecryptedObject = {} as DecryptedObject;
  action = { sign: false, refuse: false };
  signatures: any[] = [];
  attachments = { content: [], isLoading: false };
  fileAttachments: FileAttachment[] = [];
  activeFileAttachment: FileAttachment = {} as FileAttachment;
  isAddAttachmentDisabled = true;
  currentTransactionDocumentId = 0;
  partiallyApprovement = false;
  showPostponedColumns = false;
  removePostponedModal = false;
  fileAttachmentsDateState: MedInputStateType = "";
  protected readonly alert = alert;

  ngOnInit(): void {
    const param: string|null = this.route.snapshot.paramMap.get("id");
    if (param !== null) {
      this.distributionId = Number.parseInt(param, 10);
      this.loadingCounter++;
      this.distributionController.getDistributionDoz(this.distributionId).subscribe(data => {
        this.distribution = data;
        this.dataToSign.id = this.distribution.regionRecipientId;
        this.dataToSign.comment = "";
        this.signed = this.distribution.signStatus === "SIGNED" || this.distribution.signStatus === "PARTIALLY_APPROVED";
        this.distributionApproved = this.signed;
        if (this.distribution && this.distribution.goodSpecifications) {
          this.distribution.goodSpecifications.forEach(goodSpecification => {
            goodSpecification.beneficiaries?.forEach(beneficiary => {
              if (beneficiary.quantityDoz
                && beneficiary.quantityExpert
                && ((beneficiary.quantityDoz - beneficiary.quantityExpert) > 0)
                && (!beneficiary.transactionDocumentId && !beneficiary.errorMessage && !beneficiary.accountingDocumentType)) { // @ts-ignore
                this.selectOptions.push({ label: beneficiary.organization?.shortName, value: beneficiary.organization?.id });
                if (beneficiary.id != null) {
                  this.selectedBeneficiariesId.push(beneficiary.id);
                }
              } else if (beneficiary.quantityDoz && !beneficiary.quantityExpert
                && (!beneficiary.transactionDocumentId && !beneficiary.errorMessage && !beneficiary.accountingDocumentType)) {
                // @ts-ignore
                this.selectOptions.push({ label: beneficiary.organization?.shortName, value: beneficiary.organization?.id });
                if (beneficiary.id != null) {
                  this.selectedBeneficiariesId.push(beneficiary.id);
                }
              }
            });
          });
          this.selectOptions = this.selectOptions.filter((item, pos) => this.selectOptions.map(e => e.value).indexOf(item.value) == pos);
        }
        this.distribution.goodSpecifications.forEach(goodSpecification => {
          goodSpecification.beneficiaries?.forEach(beneficiary => {
            if (beneficiary.postponedDate) {
              this.showPostponedColumns = true;
              beneficiary.postponedDate = new Date(beneficiary.postponedDate);
            }
          });
        });
        this.loadingCounter--;
        this.signatures = this.distribution.signatures;
      });
    }
    this.fileAttachments = [];
    const fileAttachment: FileAttachment = {} as FileAttachment;
    fileAttachment.selectedDate = new Date();
    fileAttachment.type = "Наказ";
    if (this.distribution) {
      fileAttachment.number = this.distribution.orderName;
    }
    this.activeFileAttachment = fileAttachment;
    this.fileAttachments.push(fileAttachment);
    this.loadColumnOrder("distributionDozColumnOrder", "tabHeader");
    this.loadColumnOrder("subColumnOrder", "subTabHeader");
    this.loadColumnOrder("attachemntsDozColumnOrder", "attachmentsTabHeader");
    this.getAttachmentsMetaData();
  }

  saveColumnOrder(key: string, tabHeader: any[]) {
    localStorage.setItem(key, JSON.stringify(tabHeader));
  }

  loadColumnOrder(key: string, tabHeader: keyof this) {
    const savedOrder = localStorage.getItem(key);
    if (savedOrder) {
      this[tabHeader] = JSON.parse(savedOrder);
    }
  }

  setAccess(distributionStatus: string) {
    if (this.dataService.isMZU() && ("DRAFT") === distributionStatus) {
      this.READONLY = true;
    }
  }

  getPathToStatusImg(rowElement: string): string {
    let color: string;
    if (rowElement === "draft") {
      color = "grey";
    } else {
      color = "green";
    }
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  getPathToStatusToRedImg(): string {
    const color = "red";
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  getPathToStatusToYellowImg(): string {
    const color = "yellow";
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  getPathToStatusToGreenImg(): string {
    const color = "green";
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  goToDistributions() {
    this.router.navigate(["/distributions/doz"]);
  }

  signDistribution(): void {
    this.signRequestCounter++;
    if (this.partiallyApprovement && this.distribution && this.distribution.region && this.distribution.region.id) {
      this.distributionController.confirmDistribution(this.distributionId, true).subscribe(data => {
        this.distribution.signStatus = "PARTIALLY_APPROVED";
        this.signRequestCounter--;
        this.signed = true;
        this.action.sign = false;
      });
    } else {
      this.distributionController.confirmDistribution(this.distributionId, false).subscribe(() => {
        this.distribution.signStatus = "SIGNED";
        this.signRequestCounter--;
        this.signed = true;
        this.action.sign = false;
      }, (error: HttpErrorResponse) => {
        this.notificationService.error(error.error.detail);
        this.signRequestCounter--;
        this.signed = false;
      });
    }
  }

  refuseDistribution(): void {
    this.refuseRequestCounter++;
    // setTimeout(() => {

    this.distributionController.refusal(this.distributionId).subscribe(() => {
      this.refuseRequestCounter--;
      this.refused = true;
      this.action.refuse = false;

    });
    // }, 500);
  }

  signDone(): void {
    setTimeout(() => {
      this.signed = false;
      this.distributionApproved = true;
      this.READONLY = true;
      this.reloadComponent("Розподіл підтверджено");
    }, 100);
    this.signModal = false;
  }

  refuseDone(): void {
    setTimeout(() => {
      this.refused = false;
      this.reloadComponent("Відмова від розподілу прийнята");
    }, 100);
    this.refuseModal = false;
  }

  createSubDistribution(): void {
    this.subDistributionAgreementModal = false;
    this.showSubDistributionCreationView = true;
  }

  goToBasketDoz(): void {
    this.router.navigate(["/distribution/doz/basket"]);
  }

  save(openSignModal: boolean) {
    const dataToBackend: DistributionDozQuantityRequest [] = [];
    if (this.distribution && this.distribution.goodSpecifications) {
      this.distribution.goodSpecifications.forEach(goodSpecification => {
        if (goodSpecification.beneficiaries) {
          goodSpecification.beneficiaries.forEach(beneficiary => {
            if (this.showPostponedColumns) {
              dataToBackend.push({
                id: beneficiary.id,
                quantityDoz: beneficiary.quantityDoz,
                postponedQuantity: beneficiary.postponedQuantity,
                postponedDate: beneficiary.postponedDate,
              } as DistributionDozQuantityRequest);
            } else {
              dataToBackend.push({
                id: beneficiary.id,
                quantityDoz: beneficiary.quantityDoz,
              } as DistributionDozQuantityRequest);
            }
          });
        }
      });
    }
    if (dataToBackend) {
      this.distributionController.updateDistributedQuantity(dataToBackend).subscribe(data => {
        this.notificationService.success("Збережено");
        console.log("Quantity: ");
        console.log(data);
        if (data != null && data > 0) {
          this.partiallyApprovement = true;
        }
        if (openSignModal) {
          this.fileAttachments = [];
          const fileAttachment: FileAttachment = {} as FileAttachment;
          fileAttachment.selectedDate = new Date();
          if (this.distribution) {
            // fileAttachment.number = this.distribution.orderName;
          }
          this.activeFileAttachment = fileAttachment;
          this.fileAttachments.push(fileAttachment);
          this.signModal = true;
        }
      }, (error: HttpErrorResponse) => {
        this.notificationService.error(JSON.parse(error.error).detail);
      });
    }
  }

  reloadComponent(text?: string) {
    const { url } = this.router;
    this.router.navigateByUrl("/refreshing", { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]).then(() => {
        if (text) {
          this.notificationService.success(text);
        }
      });
    });
  }

  getValidationState(beneficiary: any): MedInputStateType {
    if (beneficiary.errorMessage) {
      return "error";
    }
    // @ts-ignore
    return this.validations[beneficiary.id];
  }

  getValidationStatePostponed(beneficiary: any): MedInputStateType {
    if (beneficiary.errorMessage) {
      return "error";
    }
    // @ts-ignore
    return this.validationsPostponed[beneficiary.id];
  }

  distributionHasValidationErrors(): boolean {
    // @ts-ignore
    return Object.keys(this.validations).some(key => this.validations[key] === "error") || Object.keys(this.validationsPostponed).some(key => this.validationsPostponed[key] === "error");
  }

  validateBase(row: RegistryDozSpecificationDto): void {
    let count = 0;
    let multiplicityError = false;
    if (row.beneficiaries) {
      row.beneficiaries.forEach((beneficiar: DistributionBeneficiaryDto) => {
        if (beneficiar.quantityDoz) {
          const quantity = Number.parseInt(beneficiar.quantityDoz + "", 10);
          count += quantity;
          if (quantity != 0 && (quantity < row.multiplicity || (quantity % row.multiplicity > 0))) {
            this.notificationService.error("Введена кількість не відповідає кратності для отримувача " +
               beneficiar.organization?.shortName);
            // @ts-ignore
            this.validations[beneficiar.id] = "error";
            multiplicityError = true;
          } else {
            // @ts-ignore
            this.validations[beneficiar.id] = "success";
          }
        }
      });
    }

    let sumUpError = false;
    if (!multiplicityError) {
      if (row.distributedQuantity < count) {
        // @ts-ignore
        row.beneficiaries.forEach((beneficiar: DistributionBeneficiaryDto) => {
          if (beneficiar.id) {
            // @ts-ignore
            this.validations[beneficiar.id] = "error";
            sumUpError = true;
          }
        });
      } else {
        // @ts-ignore
        row.beneficiaries.forEach((beneficiar: DistributionBeneficiaryDto) => {
          if (beneficiar.id) {
            // @ts-ignore
            this.validations[beneficiar.id] = "success";
          }
        });
      }
    }
    if (sumUpError) {
      this.notificationService.error("Розподілена по базам кількість більша ніж розподілило МЗУ");
    }
  }

  validateBasePostponed(row: RegistryDozSpecificationDto): void {
    let count = 0;
    let multiplicityError = false;
    if (row.beneficiaries) {
      row.beneficiaries.forEach((beneficiar: DistributionBeneficiaryDto) => {
        if (beneficiar.postponedQuantity) {
          const quantity = Number.parseInt(beneficiar.postponedQuantity + "", 10);
          count += quantity;
          if (quantity != 0 && (quantity < row.multiplicity || (quantity % row.multiplicity > 0))) {
            this.notificationService.error("Введена відтермінована кількість не відповідає кратності для отримувача " +
              beneficiar.organization?.shortName);
            // @ts-ignore
            this.validationsPostponed[beneficiar.id] = "error";
            multiplicityError = true;
          } else {
            // @ts-ignore
            this.validationsPostponed[beneficiar.id] = "success";
          }
        }
      });
    }

    let sumUpError = false;
    if (!multiplicityError) {
      if (row.distributedQuantity < count) {
        // @ts-ignore
        row.beneficiaries.forEach((beneficiar: DistributionBeneficiaryDto) => {
          if (beneficiar.id) {
            // @ts-ignore
            this.validationsPostponed[beneficiar.id] = "error";
            sumUpError = true;
          }
        });
      } else {
        // @ts-ignore
        row.beneficiaries.forEach((beneficiar: DistributionBeneficiaryDto) => {
          if (beneficiar.id) {
            // @ts-ignore
            this.validationsPostponed[beneficiar.id] = "success";
          }
        });
      }
    }
    if (sumUpError) {
      this.notificationService.error("Відтермінована по базам кількість більша ніж розподілило МЗУ");
    }
  }

  onInput(organizationId: number): void {
    if (organizationId) {
      this.distribution.goodSpecifications.forEach(goodSpecification => {
        goodSpecification.beneficiaries?.forEach(beneficiary => {
          if (beneficiary.id && this.selectedBeneficiariesId.includes(beneficiary.id)) {
            if (!this.goodSpecsForSelection.some(spec => spec.specificationId === goodSpecification.specificationId)) {
              this.goodSpecsForSelection.push(goodSpecification);
            }
          }
        })
      })
    } else {
      this.goodSpecsForSelection = [];
    }
  }

  getDistributedQuantityForBase(row: RegistryDozSpecificationDto): string {
    let retValue = "0";
    if (this.selectedBaseId && row) {
      const beneficiar = row.beneficiaries?.find(beneficiar => beneficiar.organizationId === this.selectedBaseId);
      if (beneficiar && beneficiar.quantityDoz) {
        retValue = beneficiar.quantityDoz + "";
      }
    }
    return retValue;
  }

  getAvailableQuantityForBase(row: RegistryDozSpecificationDto): string {
    let retValue = "0";
    let expert = 0;
    if (this.selectedBaseId && row) {
      const beneficiar = row.beneficiaries?.find(beneficiar => beneficiar.organizationId === this.selectedBaseId);
      if (beneficiar && beneficiar.quantityExpert) {
        expert = beneficiar.quantityExpert;
      }
    }
    let doz = 0;
    if (this.selectedBaseId && row) {
      const beneficiar = row.beneficiaries?.find(beneficiar => beneficiar.organizationId === this.selectedBaseId);
      if (beneficiar && beneficiar.quantityDoz) {
        doz = beneficiar.quantityDoz;
      }
    }
    retValue = (doz - expert) + "";
    return retValue;
  }

  onChangeHandlerSpecification(row: RegistryDozSpecificationDto): void {
    if (this.basket.containsSpecification(row)) {
      this.basket.delete(row);
    } else {
      this.basket.setupSelectedBaseId(this.selectedBaseId);
      this.basket.add(row);
    }
  }

  onSign(sign: string) {
    this.cryptoController.verify(sign).subscribe(decryptedObject => {
      this.decryptedObject = decryptedObject;
      this.medSignModal = false;
      if (this.action.sign) {
        this.signDistribution();
      } else if (this.action.refuse) {
        this.refuseDistribution();
      }
    });
  }

  sign() {
    this.dataToSign.status = "SIGNED";
    this.action.sign = true;
    if (env.production) {
      this.medSignModal = true;
    } else {
      this.signDistribution();
    }
  }

  refuse() {
    this.dataToSign.status = "REJECTED";
    this.action.refuse = true;
    if (env.production) {
      this.medSignModal = true;
    } else {
      this.refuseDistribution();
    }
  }

  signerFullName(): string {
    let signerFullName = "";
    if (this.distribution && this.distribution.signatures && this.distribution.signatures[0]) {
      const signature = this.distribution.signatures[0].signature as DecryptedObject;
      if (signature) {
        signerFullName = signature.signerInfo.subjFullName;
      }
    }
    return signerFullName;
  }

  signerDate(): string {
    let signerDate = "";
    if (this.distribution && this.distribution.signatures && this.distribution.signatures[0]) {
      const signature = this.distribution.signatures[0].signature as DecryptedObject;
      if (signature) {
        signerDate = signature.signedAt;
      }
    }
    return signerDate;
  }

  protected readonly JSON = JSON;
  visible = false;
  accountingSignModal = false;
  dataToSignAccounting = "";
  testInstanceDate: any = new Date();

  downloadFile(row: DistributionDocument) {
    const url = this.documentFileApiService.getBaseUrl() + `/${row.fileId}/files`;
    this.downloadService.download(url, null, null, row.fileName);
  }

  getAttachmentsMetaData() {
    this.documentsController.getAllForDistribution(this.distributionId).subscribe(data => {
      // @ts-ignore
      this.attachments.content = data;
    });
  }

  openAttachmentsModal() {
    this.attachments.isLoading = true;
    this.attachmentsModal = true;
    this.documentsController.getAllForDistribution(this.distributionId).subscribe(data => {
      // @ts-ignore
      this.attachments.content = data;
      this.attachments.isLoading = false;
    });
  }

  downloadExcel() {
    const baseUrl = `${env.logisticsServiceBackend}/logistics/v1/distributions/doz/export/`;
    this.downloadService.download(baseUrl + this.distributionId + "?type=SUMMARY", null, null, "distribution_" + this.distributionId + ".xlsx");
  }

  beneficiaryUpdate() {
    this.beneficiaryController.beneficiariesUpdate(this.distributionId)
      .pipe(
        catchError(response => {
          this.notificationService.error(JSON.parse(response.error).detail);
          throw response;
        }),
      )
      .subscribe(() => {
        this.reloadComponent("Дані по отримувачам оновлено");
      });
  }

  clearPostponed() {
    this.beneficiaryController.clearPostponed(this.distributionId)
      .pipe(
        catchError(response => {
          this.notificationService.error(JSON.parse(response.error).detail);
          throw response;
        }),
      )
      .subscribe(() => {
        this.reloadComponent("Дані по відтермінуванню видалено");
      });
  }

  onFileInput(file: string | File): void {
    if (!file) {
      return;
    }
    const data = new FormData();
    data.append("file", file);

    this.dataToSign.orderDate = this.activeFileAttachment.selectedDate.toString();
    this.dataToSign.orderName = this.activeFileAttachment.number;

    this.documentFileApiService.uploadFile(this.distribution?.regionDocumentId as MedID, data).subscribe(data => {
      const dat = data as any;
      if (dat && dat.body) {
        const response: FileCreationResponse = dat.body as FileCreationResponse;
        if (response) {
          const fileDocument: DistributionDocument = {} as DistributionDocument;
          fileDocument.fileId = response.id + "";
          fileDocument.distributionId = this.distributionId;
          fileDocument.fileName = response.filename;
          fileDocument.type = this.activeFileAttachment.type;
          fileDocument.selectedDate = this.activeFileAttachment.selectedDate;
          fileDocument.fileNumber = this.activeFileAttachment.number;
          fileDocument.lastUpdate = response.modifiedAt;
          fileDocument.owner = this.accountService.organizationShortName();

          this.documentsController.createFileInDocument(fileDocument).subscribe(() => {
            this.notificationService.success(`Файл '${fileDocument.fileName}' завантажено`);
            this.getAttachmentsMetaData();
            this.isAddAttachmentDisabled = false;
          });
        }
      }
    });
  }

  showRefuseModal() {
    this.refuseModal = true;
    this.fileAttachments = [];
    const fileAttachment: FileAttachment = {} as FileAttachment;
    this.activeFileAttachment = fileAttachment;
    this.fileAttachments.push(fileAttachment);
  }

  getStatus(): string {
    if (!this.distribution) {
      return "";
    }
    return this.statusTranslatorService.getStatusForString(this.distribution.status);
  }

  getDiff(quantityDoz: number|null, quantityExpert: number|null): string {
    let retValue = "";
    if (quantityDoz && quantityExpert) {
      retValue = "(доступно " + (quantityDoz - quantityExpert) + ")";
    }
    return retValue;
  }

  // addFileAttachment() {
  //   const attachment = {} as FileAttachment;
  //   // @ts-ignore
  //   // attachment.number = this.distribution?.orderName;
  //   attachment.selectedDate = new Date();
  //   this.activeFileAttachment = attachment;
  //   this.fileAttachments.push(attachment);
  //   this.isAddAttachmentDisabled = true;
  // }

  addFileAttachmentRefuse() {
    const attachment = {} as FileAttachment;
    // @ts-ignore
    // attachment.number = this.distribution?.orderName;
    attachment.selectedDate = new Date();
    this.activeFileAttachment = attachment;
    this.fileAttachments.push(attachment);
    this.isAddAttachmentDisabled = true;
  }

  addFileAttachment() {
    const attachment = {} as FileAttachment;
    // @ts-ignore
    attachment.number = this.fileAttachments[0].number;
    attachment.selectedDate = this.fileAttachments[0].selectedDate;
    attachment.type = this.fileAttachments[0].type;
    // this.activeFileAttachment = attachment;
    this.fileAttachments.push(attachment);
    // this.isAddAttachmentDisabled = true;
    console.log(this.fileAttachments)
  }

  deleteAttachment() {
    this.fileAttachments.pop();
  }

  deleteAttachmentNumber(index: number) {
    this.fileAttachments.splice(index, 1);
  }

  approveReceipt(transactionDocumentId: number) {
    this.currentTransactionDocumentId = transactionDocumentId;
    this.visible = true;

    this.distributionController.testHashForAccounting(this.currentTransactionDocumentId).subscribe(data => {
      this.dataToSignAccounting = data;
    });

    // this.distributionController.getHash(transactionDocumentId).subscribe(data => {
    //   console.log(data);
    // })
  }

  onSignAccounting(hash: string) {
    this.distributionController.confirm(this.currentTransactionDocumentId, hash).subscribe(data => {
      this.accountingSignModal = false;
      this.reloadComponent("Розподіл на базу підтверджений ЗОЗ юзером");
    });
  }

  apprReceipt() {
    if (env.production) {
      this.accountingSignModal = true;
    } else {
      this.onSignAccounting("test");
    }
    this.visible = false;
  }

  declineReceipt(transactionDocumentId: any, text: string) {
    this.distributionController.setDocumentType(transactionDocumentId, text).subscribe(() => {
      this.reloadComponent("Отримано лист про відмову від отримання");
    });
  }

  getMnnName(spec: any) {
    return spec["good"]["mnnName"];
  }

  removePostponed(): void {
    this.showPostponedColumns = false;
    this.removePostponedModal = false;
    this.clearPostponed();
  }

  validateFileAttachmentDate(newDate: Date) {
    console.log(newDate);
    console.log("validate date")

    let selectedDate: number = newDate.getTime();
    let today: number = new Date().getTime();

    if (selectedDate > today) {
      this.notificationService.error("Оберіть дату в минулому або сьогодні");
      this.fileAttachmentsDateState = "error";
    } else {
      this.fileAttachmentsDateState = "success";
    }
  }
}
